import { FunctionalComponent, h } from 'preact'
// Too much files to change
// eslint-disable-next-line import/no-internal-modules
import { ProductAreaType } from '../../../../control-components/product-areas/ProductAreaSelect'

interface FeaturedProductAreasProps {
  fullWidth: boolean
  allProductAreas: ProductAreaType[]
  assignedProductAreas: string[]
}

const FeaturedProductAreas: FunctionalComponent<FeaturedProductAreasProps> = ({ fullWidth, allProductAreas, assignedProductAreas }) => {
  const productAreaMapping = allProductAreas.reduce<Record<string, string>>((acc, productArea) => {
    acc[productArea.id] = productArea.name
    return acc
  }, {})

  if (fullWidth) {
    return (
      <ul className='featured-topic__product-areas'>
        {assignedProductAreas.map((assignedProductArea) => (
          <li
            key={assignedProductArea}
            className='featured-topic__product-area'
          >
            {productAreaMapping[assignedProductArea]}
          </li>
        ))}
      </ul>
    )
  }
  return (
    <ul className='featured-topic__product-areas'>
      <li className='featured-topic__product-area'>
        {productAreaMapping[assignedProductAreas[0]]}
      </li>
      {assignedProductAreas.length > 1 && (
        <li
          className='featured-topic__product-area-count'
          aria-label='Count of assigned product areas'
        >
          {`+ ${assignedProductAreas.length - 1}`}
        </li>
      )}
    </ul>
  )
}

export default FeaturedProductAreas
